/* product-qa.js — «أسئلة القرّاء» تحت تقييمات الكتاب (2026-10-30)
   الأسئلة والأجوبة من Judge.me كـHTML، ننقرا منها النص بـDOMParser (ما يشغّل أي سكربت)،
   ونرسمها كأسئلة تنفتح وتتسكّر (details) بتصميم الثيم، كنص فقط. */
(() => {
  if (customElements.get('asoule-qa')) return;

  const MONTHS = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
  const API = 'https://judge.me/api/questions/questions_for_widget';
  const CHEVRON = '<svg class="prv-q__chev" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>';

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const textOf = (node) => {
    if (!node) return '';
    const c = node.cloneNode(true);
    c.querySelectorAll('br').forEach((b) => b.replaceWith('\n'));
    c.querySelectorAll('p').forEach((p) => p.append('\n'));
    return (c.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
  };

  class AsouleQA extends HTMLElement {
    connectedCallback() {
      this.shop = this.dataset.shop;
      this.productId = this.dataset.productId;
      this.perPage = parseInt(this.dataset.perPage, 10) || 5;
      this.total = parseInt(this.dataset.total, 10) || 0;
      this.arabicNum = this.dataset.num === 'arabic';
      this.list = this.querySelector('[data-qa-list]');
      this.more = this.querySelector('[data-qa-more]');
      this.page = 0;
      this.shown = 0;
      if (this.more) this.more.addEventListener('click', () => this.load());
      this.setupAsk();
      if (!this.total) return; // ما في أسئلة: نعرض الدعوة للسؤال بس
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { io.disconnect(); this.load(); }
        }, { rootMargin: '400px 0px' });
        io.observe(this);
      } else {
        this.load();
      }
    }

    num(v) {
      const s = String(v);
      return this.arabicNum ? s.replace(/\d/g, (d) => '٠١٢٣٤٥٦٧٨٩'[d]) : s;
    }

    fmtDate(raw) {
      if (!raw) return '';
      const d = new Date(String(raw).trim().replace(' UTC', 'Z').replace(' ', 'T'));
      if (isNaN(d)) return '';
      return `${this.num(d.getUTCDate())} ${MONTHS[d.getUTCMonth()]} ${this.num(d.getUTCFullYear())}`;
    }

    async load() {
      if (this.busy) return;
      this.busy = true;
      const page = this.page + 1;
      const label = this.more && this.more.querySelector('[data-qa-more-label]');
      if (this.more && this.page) { this.more.disabled = true; if (label) label.textContent = 'لحظة…'; }
      try {
        const url = `${API}?shop_domain=${encodeURIComponent(this.shop)}&platform=shopify&product_id=${encodeURIComponent(this.productId)}&page=${page}&per_page=${this.perPage}`;
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        const doc = new DOMParser().parseFromString(String(data.html || ''), 'text/html');
        const nodes = Array.from(doc.querySelectorAll('.jdgm-quest'));
        if (!this.page) { this.list.textContent = ''; this.list.removeAttribute('aria-busy'); }
        nodes.forEach((n) => {
          const q = this.read(n);
          if (q) this.list.appendChild(this.render(q));
        });
        this.page = page;
        this.shown += nodes.length;
        if (this.more) {
          this.more.hidden = !nodes.length || this.shown >= this.total;
          this.more.disabled = false;
          if (label) label.textContent = 'أسئلة أكثر';
        }
        if (!this.list.children.length) this.list.appendChild(el('p', 'prv-qa__none', 'عندك سؤال عن الكتاب قبل ما تشتريه؟ اسألنا ونجاوبك هنا.'));
      } catch (e) {
        if (!this.page) {
          this.list.textContent = '';
          this.list.removeAttribute('aria-busy');
          this.list.appendChild(el('p', 'prv-qa__error', 'ما قدرنا نجيب الأسئلة الحين، حدّث الصفحة بعد شوي.'));
        } else if (this.more) {
          this.more.disabled = false;
          if (label) label.textContent = 'جرّب مرة ثانية';
        }
      } finally {
        this.busy = false;
      }
    }

    read(n) {
      const question = textOf(n.querySelector('.jdgm-quest__body'));
      if (!question) return null;
      const askerEl = n.querySelector('.jdgm-quest__asker .jdgm-rev__author');
      const ts = n.querySelector(':scope > .jdgm-rev__header .jdgm-rev__timestamp') || n.querySelector('.jdgm-rev__timestamp');
      const answers = Array.from(n.querySelectorAll('.jdgm-ans')).map((a) => {
        const by = a.querySelector('.jdgm-ans__answerer .jdgm-rev__author');
        const t = a.querySelector('.jdgm-rev__timestamp');
        return {
          by: by ? by.textContent.trim() : '',
          text: textOf(a.querySelector('.jdgm-ans__body')),
          date: t ? t.getAttribute('data-content') : '',
        };
      }).filter((a) => a.text);
      return {
        question,
        asker: askerEl ? askerEl.textContent.trim() : '',
        date: ts ? ts.getAttribute('data-content') : '',
        answers,
      };
    }

    render(q) {
      const d = el('details', 'prv-q');
      const s = el('summary', 'prv-q__sum');
      s.appendChild(el('span', 'prv-q__mark', 'س')).setAttribute('aria-hidden', 'true');
      s.appendChild(el('span', 'prv-q__text', q.question));
      s.insertAdjacentHTML('beforeend', CHEVRON);
      d.appendChild(s);

      const body = el('div', 'prv-q__body');
      const metaBits = [];
      if (q.asker) metaBits.push(`سأل: ${q.asker}`);
      const when = this.fmtDate(q.date);
      if (when) metaBits.push(when);
      if (metaBits.length) body.appendChild(el('p', 'prv-q__meta', metaBits.join(' · ')));

      if (q.answers.length) {
        q.answers.forEach((a) => {
          const box = el('div', 'prv-item__reply prv-q__ans');
          box.appendChild(el('span', 'prv-item__reply-by', a.by ? `ردّ ${a.by}` : 'الجواب'));
          box.appendChild(el('p', null, a.text));
          body.appendChild(box);
        });
      } else {
        body.appendChild(el('p', 'prv-q__wait', 'ما في جواب على هذا السؤال بعد.'));
      }
      d.appendChild(body);
      return d;
    }

    /* ---------- «اسأل سؤالًا» ----------
       يرسل لنفس عنوان Judge.me اللي يستخدمه نموذج الأسئلة حقهم، والسؤال يوصل للوحة Judge.me */
    setupAsk() {
      this.dialog = this.querySelector('dialog.prv-form');
      if (!this.dialog) return;
      const dlg = this.dialog;
      this.askForm = dlg.querySelector('[data-ask-form]');
      this.askDone = dlg.querySelector('[data-ask-done]');
      this.askErr = dlg.querySelector('[data-ask-error]');
      this.askSend = dlg.querySelector('[data-ask-send]');
      this.querySelectorAll('[data-ask]').forEach((b) => b.addEventListener('click', () => {
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        document.documentElement.classList.add('prv-lock');
      }));
      const close = () => { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); };
      dlg.querySelectorAll('[data-ask-close]').forEach((b) => b.addEventListener('click', close));
      dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
      dlg.addEventListener('close', () => {
        document.documentElement.classList.remove('prv-lock');
        if (!this.askDone.hidden) {
          this.askForm.reset();
          this.askForm.hidden = false;
          this.askDone.hidden = true;
        }
      });
      this.askForm.addEventListener('submit', (e) => { e.preventDefault(); this.ask(); });
    }

    askError(text, field) {
      this.askErr.textContent = text;
      this.askErr.hidden = false;
      if (field) field.focus();
    }

    askFinish() {
      this.askForm.hidden = true;
      this.askDone.hidden = false;
      const ok = this.askDone.querySelector('[data-ask-close]');
      if (ok) ok.focus();
    }

    async ask() {
      const f = this.askForm;
      const data = new FormData(f);
      const question = String(data.get('question') || '').trim();
      const name = String(data.get('name') || '').trim();
      const email = String(data.get('email') || '').trim();
      this.askErr.hidden = true;
      if (question.length < 3) return this.askError('اكتب سؤالك.', f.elements.question);
      if (!name) return this.askError('اكتب اسمك.', f.elements.name);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.askError('اكتب إيميل صحيح.', f.elements.email);
      if (String(data.get('website') || '').trim()) return this.askFinish();

      const params = new URLSearchParams({
        shop_domain: this.shop,
        platform: 'shopify',
        id: this.productId,
        product_title: this.dataset.productTitle || '',
        handle: this.dataset.handle || '',
        name,
        email,
        question_content: question,
      });
      this.askSend.disabled = true;
      this.askSend.setAttribute('aria-busy', 'true');
      const oldLabel = this.askSend.textContent;
      this.askSend.textContent = 'قاعد نرسل…';
      try {
        const res = await fetch('https://api.judge.me/api/questions', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
          body: params.toString(),
        });
        if (!res.ok) throw new Error(res.status);
        this.askFinish();
      } catch (e) {
        this.askError('ما وصل السؤال، جرّب مرة ثانية بعد شوي.');
      } finally {
        this.askSend.disabled = false;
        this.askSend.removeAttribute('aria-busy');
        this.askSend.textContent = oldLabel;
      }
    }
  }

  customElements.define('asoule-qa', AsouleQA);
})();
